import React from "react";

const Footer = () => {
    return <div className="footer">
        <div className="footer-sub-info">
            What is a Customer Data Platform?
        </div>
        <div className="footer-sub-box">
            <a href="#">
                Privacy
            </a>
            <a href="#">
                Terms
            </a>
        </div>
    </div>
}

export default Footer;